import { css } from "@emotion/react";
import { ThemedCssCreator } from "../../../../../../config/emotion";

export const buttonCss: ThemedCssCreator = ({ colors }) => css`
  background-color: ${colors.save};
  margin-bottom: 10px;
  margin-top: 5px;
  height: 40px;
`;
